<template>
  <v-row class="d-flex align-center py-3 pl-5 borer-footer-table">
    <div class="left-footer">
      <span class="text-caption text-sm-subtitle-2 text-md-subtitle-1"
        >レコード数</span
      >
      <div class="itemPerPage mx-3">
        <v-select
          height="24"
          :hide-details="true"
          dense
          :items="itemsPerPageOption"
          v-model="request.limit"
          single-line
          outlined
          @change="
            () => {
              this.request.page = 1;
              fetchData();
            }
          "
        ></v-select>
      </div>
      <span class="mx-2">{{ calcRange }}</span>
    </div>
    <v-row cols="12" class="right-footer" v-if="page.count > 0">
      <v-pagination
        v-model="request.page"
        :circle="paging.circle"
        :length="Math.ceil(page.count / request.limit)"
        :next-icon="paging.nextIcon"
        :prev-icon="paging.prevIcon"
        :page="request.page"
        :total-visible="paging.totalVisible"
        @input="fetchData"
        class="custom-pagination"
      ></v-pagination>
    </v-row>
  </v-row>
</template>

<script>
export default {
  name: "TableFooter",
  props: {
    page: {
      type: Object,
      required: true,
    },
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paging: {
        circle: true,
        length: 10,
        nextIcon: "mdi-chevron-right",
        prevIcon: "mdi-chevron-left",
        page: 1,
        totalVisible: 10,
      },
      itemsPerPageOption: [10, 20, 50, 100],
    };
  },
  computed: {
    calcRange() {
      if (this.page.count > 0) {
        let start = (this.request.page - 1) * this.request.limit;
        let end = start + this.request.limit;
        if (end > this.page.count) {
          end = this.page.count;
        }
        return start + 1 + " - " + end + " の " + this.page.count;
      }
      return "0 - 0 の 0";
    },
  },
  methods: {
    fetchData() {
      this.$emit("fetchData");
    },
  },
};
</script>

<style lang="scss" scoped></style>
